var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFamilyHaven = function SvgFamilyHaven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9V4.91667C20 3.30613 18.6566 2 17 2C15.3435 2 14 3.30613 14 4.91667L14 9H20Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50423 21.9958C8.39801 21.9981 7.46303 21.0787 7.80985 20.0282C8.34386 18.4108 9.61688 17 12 17C14.3855 17 15.6587 18.4035 16.1918 20.0175",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.9886L4.00381 18.9962C2.89775 18.9983 1.96976 18.0838 2.28417 17.0234C2.90624 14.9254 4.61148 13 8 13C8.64575 13 9.23037 13.0694 9.75801 13.1963",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2019 13.2075C14.74 13.0735 15.3379 13 16.0001 13C19.3911 13 21.0963 14.9143 21.7173 17.008C22.0309 18.0656 21.107 18.9789 20.0039 18.981L16.0001 18.9886",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5.5C11 7.43264 9.43264 9 7.5 9C5.56736 9 4 7.43264 4 5.5C4 3.56736 5.56736 2 7.5 2C9.43264 2 11 3.56736 11 5.5Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 14.5C14.5 15.8805 13.3805 17 12 17C10.6195 17 9.5 15.8805 9.5 14.5C9.5 13.1195 10.6195 12 12 12C13.3805 12 14.5 13.1195 14.5 14.5Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFamilyHaven;